import { Contract } from "../../../../../type/entities/contract-type";
import { formatInfoValue, InfoCard, InfoField, InfoGroup, InfoTextField } from "./components/InfoDisplay";

interface ConsultancyContractFormInfoProps {
    data: Contract;
}

const ConsultancyContractFormInfo = ({ data }: ConsultancyContractFormInfoProps) => {
    return (
        <InfoCard title="Datos de la Asesoría" subtitle="Asesoría asociada al contrato.">
            <InfoGroup title="Información General" description="Datos de contacto y referencia de la asesoría.">
                <InfoField label="Nombre" value={formatInfoValue(data?.consultancyName ?? data?.consultancy?.name)} className="md:col-span-4" />
                <InfoField label="Correo Electrónico" value={formatInfoValue(data?.consultancyEmail ?? data?.consultancy?.email)} className="md:col-span-4" />
                <InfoField label="CIF" value={formatInfoValue(data?.consultancyCif ?? data?.consultancy?.cif)} className="md:col-span-4" />
                <InfoField label="Persona de Contacto" value={formatInfoValue(data?.consultancyContact ?? data?.consultancy?.contact)} className="md:col-span-4" />
                <InfoField label="Teléfono" value={formatInfoValue(data?.consultancyTelephone ?? data?.consultancy?.telephone)} className="md:col-span-4" />
                <InfoField label="Teléfono Secundario" value={formatInfoValue(data?.consultancyTelephoneSecondary ?? data?.consultancy?.telephoneSecondary)} className="md:col-span-4" />
                <InfoTextField label="Descripción" value={data?.consultancyDescription ?? data?.consultancy?.description ?? ""} />
            </InfoGroup>
        </InfoCard>
    );
};

export default ConsultancyContractFormInfo;
